const CreationForm = () => import(/*webpackChunkName: "calendar" */ "@/pages/rate-calendar/CreationForm");
const CreationBulkForm = () => import(/*webpackChunkName: "calendar" */ "@/pages/rate-calendar/CreationBulkForm");
const CopyForm = () => import(/*webpackChunkName: "calendar" */ "@/pages/rate-calendar/CopyForm");
const ViewDrawer = () => import(/*webpackChunkName: "calendar" */ "@/pages/reservations/ViewDrawer");
const EditingForm = () => import(/*webpackChunkName: "calendar" */ "@/pages/reservations/EditingForm");
const CreationWizardForm = () => import(/*webpackChunkName: "calendar" */ "@/pages/reservations/CreationWizardForm");
const CreationMultipleForm = () => import(/*webpackChunkName: "calendar" */ "@/pages/reservations/CreationMultipleForm");

import {
  REPLACE_RESERVATIONS
} from "@/store/reservations/actions";

import {
  REPLACE_UNITS
} from "@/store/units/actions";

import {
  GET_ROOM_TYPES_SINGLE
} from "@/store/room-types/actions";

import MixpanelEvents from "@/constants/events";

export default {
  components: {
    CreationForm,
    CreationBulkForm,
    CopyForm,
    ViewDrawer,
    EditingForm,
    CreationWizardForm,
    CreationMultipleForm,
  },
  data() {
    return {
      activeId: null,
      activeUnitId: null,
      activeUnitCategoryId: null,
      activeDerivationRuleId: null,
      activePricePerGuestPayload: null,
      creationData: null,
      creationWizardOptions: {},
      isOpenCreation: false,
      isOpenBulkCreation: false,
      isOpenView: false,
      isOpenEditing: false,
      isOpenCreationWizard: false,
      isOpenCreationMultiple: false,
      isOpenUnitEditingForm: false,
      isOpenUnitCategoryEditingForm: false,
      isOpenDerivationRuleEditingForm: false,
      isOpenCopy: false,
      isOpenPricePerGuestConfig: false,
    }
  },
  methods: {
    reservationReplace(data) {
      if (!data.id) {
        return;
      }

      this.$store.dispatch(REPLACE_RESERVATIONS, {
        id: data.id,
        params: { ...data }
      }).then((response) => {
        this.getData();
        this.$emit("success", response);
      });
    },
    openCreation(data) {
      this.isOpenCreation = true;
      this.creationData = data;
    },
    closeCreation() {
      this.isOpenCreation = false;
      this.creationData = null;
    },
    openBulkCreation() {
      this.isOpenBulkCreation = true;
    },
    closeBulkCreation() {
      this.isOpenBulkCreation = false;
    },
    openCopy() {
      this.isOpenCopy = true;
    },
    closeCopy() {
      this.isOpenCopy = false;
    },
    failed() {
      this.showNotification('😅 ' + this.$lang("main.crud.something_went_wrong"), "error");
    },
    created() {
      this.request.loading = false;
      this.closeCreation();
      this.getData();
      this.showNotification(this.$lang("main.crud.success_create"), "success");
    },
    failedBulk(response) {
      this.showNotification(response, "error");
    },
    createdBulk() {
      this.isOpenBulkCreation = false;
      this.showNotification(this.$lang("main.words.queued"), "success");
      this.getData();
    },
    failedCopy(response) {
      this.showNotification(response, "error");
    },
    successCopy() {
      this.closeCopy();
      this.showNotification(this.$lang("main.words.success_create"), "success");
      this.getData();
    },
    openView(id) {
      this.activeId = id;
      this.isOpenView = true;
    },
    closeView() {
      this.activeId = null;
      this.isOpenView = false;
    },
    updated() {
      this.activeId = null;
      this.isOpenView = false;
      this.isOpenEditing = false;
      this.getData();
      this.showNotification(this.$lang("main.crud.success_update"), "success");
    },
    failedEditing(response) {
      const message = response && response.message ? response.message : this.$lang("main.crud.something_went_wrong");
      this.showNotification(message, "error");
    },
    openCreationWizard(data) {
      this.creationWizardOptions = data ? data : {};
      this.isOpenCreationWizard = true;

      const source = data ? 'UNIT_ROW' : 'CALENDAR_MENU'
      this.$monitorService.track(MixpanelEvents.SINGLE_RESERVATION_NEW, {
        source: source,
      });
    },
    closeCreationWizard() {
      this.creationWizardOptions = {};
      this.isOpenCreationWizard = false;
    },
    openEditing(id) {
      if (this.$cannot('EDIT_RESERVATIONS')) {
        if (this.$can('VIEW_RESERVATIONS')) {
          this.openView(id);
        }

        return;
      }

      this.activeId = id;
      this.isOpenEditing = true;
    },
    closeEditing() {
      this.activeId = null;
      this.isOpenEditing = false;
    },
    createdWizard(response) {
      this.getData();
      this.showNotification(this.$lang("main.crud.success_create"), "success");
      this.closeCreationWizard();
    },
    failedWizard(response) {
      const message = response && response.message ? response.message : this.$lang("main.crud.something_went_wrong");
      this.showNotification(message, "error");
    },
    openCreationMultiple() {
      this.isOpenCreationMultiple = true;
      this.$monitorService.track(MixpanelEvents.MULTIPLE_RESERVATION_NEW, {
        source: 'CALENDAR_MENU',
      });
    },
    closeCreationMultiple() {
      this.isOpenCreationMultiple = false;
    },
    createdMultiple(response) {
      this.getData();
      this.showNotification(this.$lang("main.crud.success_create"), "success");
      this.closeCreationMultiple();
    },
    failedMultiple(response) {
      const message = response && response.message ? response.message : this.$lang("main.crud.something_went_wrong");
      this.showNotification(message, "error");
    },
    openUnitEditing(id) {
      this.isOpenUnitEditingForm = true;
      this.activeUnitId = id;
      this.$monitorService.track(MixpanelEvents.CALENDAR_ACTION_TRIGGERED, {
        action: 'unit_opened'
      });
    },
    closeUnitEditing() {
      this.isOpenUnitEditingForm = false;
      this.activeUnitId = null;
    },
    openUnitCategoryEditing(id) {
      this.isOpenUnitCategoryEditingForm = true;
      this.activeUnitCategoryId = id;
      this.$monitorService.track(MixpanelEvents.CALENDAR_ACTION_TRIGGERED, {
        action: 'unit_category_opened'
      });
    },
    closeUnitCategoryEditing() {
      this.isOpenUnitCategoryEditingForm = false;
      this.activeUnitCategoryId = null;
    },
    openDerivationRuleEditing(roomTypeId) {
      this.$store.dispatch(GET_ROOM_TYPES_SINGLE, {
        id: roomTypeId,
        params: {
          _data: {
            selects: [
              'id'
            ],
            relations: {
              derivation_rule: {
                selects: [
                  'id',
                  'room_type_id',
                ]
              }
            }
          }
        }
      }).then(response => {
        if(!response.derivation_rule) {
          return;
        }

        this.activeDerivationRuleId = response.derivation_rule.id;
        this.isOpenDerivationRuleEditingForm = true;
        this.$monitorService.track(MixpanelEvents.CALENDAR_ACTION_TRIGGERED, {
          action: 'derivation_rule_opened'
        });
      });
    },
    closeDerivationRuleEditing() {
      this.isOpenDerivationRuleEditingForm = false;
      this.activeDerivationRuleId = null;
    },
    openPricePerGuestConfig(payload) {
      this.isOpenPricePerGuestConfig = true;
      this.activePricePerGuestPayload = payload;
      this.$monitorService.track(MixpanelEvents.CALENDAR_ACTION_TRIGGERED, {
        action: 'price_per_guest_opened'
      });
    },
    closePricePerGuestConfig() {
      this.isOpenPricePerGuestConfig = false;
      this.activePricePerGuestPayload = null;
    },
    housekeepingClick(payload) {
      this.$store.dispatch(REPLACE_UNITS, {
        id: payload.id,
        params: payload,
      }).then(() => {
        this.getData();
        this.$monitorService.track(MixpanelEvents.CALENDAR_ACTION_TRIGGERED, {
          action: 'housekeeping_status_clicked'
        });
      });
    },
    changePeriod(value) {
      this.period = value;
      this.$monitorService.track(MixpanelEvents.CALENDAR_NAVIGATED, {
        type: 'period_list',
      });
    }
  }
}
